<template>
  <div class="rateChart">
    <div class="rate-item" v-for="(item,index) in list" :key='item.name'>
      <div class="name">
        {{item.name}}
      </div>
      <div class="actives" :style="{width:item.rate+'%'}"></div>
      <div class="data-box" :style="{left:item.rate<=20?'20%':item.rate-3+'%'}">
        {{item.rate}}%
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "rateChart",
    props:{
      list:{
        type:Array,
      },
    },
  }
</script>

<style scoped lang="scss">
  .rateChart {
    padding: 0 25px;
    margin-top: 37px;
    .rate-item{
      height:4px;
      background:#DBEBFF;
      border-radius:3px;
      margin-bottom: 36px;
      position: relative;
      .name{
        color: #B8D7FF;
        font-size: 12px;
        font-family:Helvetica;
        line-height:22px;
        position: absolute;
        left: 0;
        bottom: 6px;
      }
      .actives{
        width: 100px;
        height: 4px;
        border-radius:3px;
        background:linear-gradient(90deg,rgba(2,86,255,1) 0%,rgba(2,170,253,1) 100%);
        position: absolute;
        left: 0;
        top: 0;
        &:after{
          content: '';
          display: block;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 0;
          width: 8px;
          height: 8px;
          background: url("/img/bigdata/ellipse-icon.png") no-repeat;
          border-radius: 4px;
        }
      }
      .data-box{
        width: 36px;
        height: 24px;
        position: absolute;
        bottom: 6px;
        background: url("/img/bigdata/data-box.png") no-repeat;
        font-size: 12px;
        color: #fff;
        text-align: center;
        line-height: 20px;
      }
    }
  }
</style>
